var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7068",
    "data-name": "Ellipse 7068",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(0 0)",
    fill: "#009725"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93451",
    "data-name": "Path 93451",
    d: "M106.509,122.645l-5.2,5.7a.854.854,0,0,1-1.3,0l-2.2-2.45a.885.885,0,1,1,1.3-1.2l1.55,1.75,4.55-4.95a.877.877,0,0,1,1.25-.05A.862.862,0,0,1,106.509,122.645Z",
    transform: "translate(-94.159 -116.945)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecked);
export default __webpack_public_path__ + "static/media/green-checked.b4f1f9877a91c1976f4d1be79a027b01.svg";
export { ForwardRef as ReactComponent };